import { createFileRoute, redirect } from '@tanstack/react-router';
import { serverlessPlatformService } from '@/api/services/serverless/platform';
import { checkServerlessFeatureGate } from '@/helpers/statsig/featureGate';
import { ensureStatsigUserFeatureGateReady } from '@/helpers/statsig/featureGate/ensureStatsigUserFeatureGateReady';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/serverless-spaces')({
  beforeLoad: async ({ context, params: { accountId } }) => {
    // The serverless product is rolled out behind a feature gate.
    const { statsigClient } = context;
    await ensureStatsigUserFeatureGateReady(context);

    if (!checkServerlessFeatureGate(statsigClient)) {
      throw redirect({ to: '/accounts/$accountId/clusters', params: { accountId } });
    }

    // The spaces list and a space's overview both name its region.
    return { listServerlessRegionsQuery: serverlessPlatformService.listCloudRegionsQuery({ accountId }) };
  },
  // Region names only dress the pages: never block them on it.
  loader: ({ context: { queryClient, listServerlessRegionsQuery } }) =>
    void queryClient.prefetchQuery(listServerlessRegionsQuery),
});
